export const contentTableConfig = {
  title: '电话状态列表',
  propList: [
    {prop: 'userName', label: '客户名称', minWidth: '80'},
    {prop: 'phoneNumber', label: '客户手机号', minWidth: '80'},
    {prop: 'callStart', label: '通话开始时间', minWidth: '80'},
    {prop: 'callEnd', label: '通话结束时间', minWidth: '80'},
    {prop: 'caller', label: '归属人', minWidth: '80'},
    {prop: 'importAt', label: '导入时间', minWidth: '80'},
    {prop: 'storageTime', label: '入库时间', minWidth: '80'},
    {prop: 'storageRepetitions', label: '入库重复次数', minWidth: '80'},
    {prop: 'status', label: '状态标签', minWidth: '80', slotName: 'status'}
  ],
  showIndexColumn: false,
  showSelectColumn: false,
  action: process.env.VUE_APP_BASE_URL + '/main/phoneState/importPhoneStateData'
}
